<template>

    <div class="menu-maquinas" v-if="skuactivo !== null">
      <div class="scrolling-wrapper">
        <div class="opcion viewed" :class="puente.sku" v-for="(puente) in this.$store.getters.getPuentes" :key="'puente_scroll_'+puente.sku">
          <b-button
              type="is-ghost" @click="selPuente(puente.sku)" :class="[{activo : puente.sku == skuactivo ? true : false }, puente.sku]">
            <img
                class="prueba"
                :src="require('@/assets/img/' + puente.fotoscroll.path)"
                :alt="puente.fotoscroll.alt"
            ><br />
            <span>{{ puente["nombre"][$i18n.locale.replace('_','-').toLowerCase()] }}</span>
          </b-button>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: 'listaPuentesScroll',
  computed: {
    skuactivo(){
      if (typeof this.$store !== 'undefined'){
        if (this.$store.getters.getSKUActivo !==null){
          return this.$store.getters.getSKUActivo.replace("_Alto_Blanco",'')
        }else{
          return null
        }

      }else{
        return null
      }

    }
  },
  data(){

    return {


    }
  },
  methods: {
    selPuente(sku){
      //if (!this.$store.getters.getSKUActivo.includes(sku)){
      //if (this.$store.getters.getSKUActivo!== sku+"_Alto_Blanco"){
        //console.log("SKU _____________________:"+sku)
        //console.log("getSKU___________________:"+this.$store.getters.getSKUActivo)
        this.$store.commit('setConfigHash',null)
        this.$store.dispatch('getConfigPuenteFromBackend',sku)
        this.$store.commit('setIsMenuModalActive',false)
      //}

      this.$router.replace( '/'+this.$route.params.pais+'/'+this.$i18n.locale+'/'+sku)


      //this.parent.isMenuModalActive = false

    }
  },
  mounted: function () {



  },

}
</script>
